import React from 'react'
import MediaViewer from './MediaViewer'
import DescriptionEditor from './DescriptionEditor'
import MediaActions from './MediaActions'

const ModalContent = ({
  selectedMedia,
  isOwner,
  editingDescription,
  newDescription,
  loading,
  onStartEditDescription,
  onSaveDescription,
  onCancelEdit,
  onSetNewDescription,
  onDeleteMedia,
  onEditPhoto
}) => (
  <div className="p-6 overflow-y-auto max-h-[calc(90vh-160px)]">
    <div className="grid md:grid-cols-2 gap-6">
      <MediaViewer selectedMedia={selectedMedia} onEditPhoto={onEditPhoto} />

      <div className="space-y-4">
        <DescriptionEditor
          selectedMedia={selectedMedia}
          isOwner={isOwner}
          editingDescription={editingDescription}
          newDescription={newDescription}
          loading={loading}
          onStartEditDescription={onStartEditDescription}
          onSaveDescription={onSaveDescription}
          onCancelEdit={onCancelEdit}
          onSetNewDescription={onSetNewDescription}
        />

        <MediaActions
          selectedMedia={selectedMedia}
          isOwner={isOwner}
          loading={loading}
          onDeleteMedia={onDeleteMedia}
        />
      </div>
    </div>
  </div>
)

export default ModalContent